import axios from "axios"

export const searchEvents = async (query: string, limit: number = 100, offset: number = 0) => {
  try {
    const res = await axios.get("/admin/search/event", { params: { q: query, limit, offset } })
    return res.data
  } catch (err) {
    console.log("login err", err)
  }
  return null
}
